import styled from 'styled-components';

export const ListInscricoesEstaduais = styled.ul`
  list-style: none;
  padding: 0;
  li {
    border-bottom: solid 1px #e8e8e8;
    padding: 1rem 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: center;
    color: ${(props) => props.theme.colors.textPrimary};
  }
  li:first-child {
    padding-top: 0;
  }
  span {
    margin-right: 0.5rem;
    &:hover {
      .anticon svg {
        color: #fadb14;
      }
    }
    &:first-child {
      cursor: pointer;
    }
  }
  .activeStar .anticon svg {
    color: #fadb14;
  }
`;
